module.exports = __webpack_public_path__ + "static/media/proManagerIcon.5efab4ca.png";